module.exports = __webpack_public_path__ + "static/img/xl32.9264631.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xl32.png
// module id = C0/A
// module chunks = 73